import {
  REPORTS_SET_BRAND_SALES,
  REPORTS_RESET_BRAND_SALES,
} from 'mf-shared/actions/reports/sales/constants';
import createReducer from 'mf-shared/utils/createReducer';

const initialState = {
  itemBrandSalesReport: [],
  itemBrandSummaryReport: {},
};

const brandSales = createReducer(initialState, {
  [REPORTS_SET_BRAND_SALES]: (draft, { payload }) => payload,
  [REPORTS_RESET_BRAND_SALES]: () => initialState,
});

export default brandSales;
